import React from "react";
import AppButton from "../../../../components/AppButton";
import AppCallout from "../../../../components/AppCallout";
import { IconImport } from "../../../../icons";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const calloutVariants = [
  {
    variant: "primary",
    label: "Primary",
    icon: <IconImport />,
    description: "Mehrere Lehrpersonen erfassen?",
    action: (
      <AppButton variant="outlined" size="sm">
        <IconImport />
        Excel Import
      </AppButton>
    ),
  },
  {
    variant: "success",
    label: "Success",
    description: "Daten erfolgreich importiert",
  },
  {
    variant: "info",
    label: "Info",
    title: "Hinweis",
    description: "Der INFO-Callout wird vielleicht durch PRIMARY ersetzt",
  },
  {
    variant: "warning",
    label: "Warning",
    title: "Korrektur nötig",
    description: "3 Zeilen benötigen vor dem Import noch eine Korrektur.",
  },
  {
    variant: "error",
    label: "Error",
    title: "Import fehlgeschlagen",
    description: "Die Datei konnte nicht verarbeitet werden.",
  },
];

const niceToKnowItems = [
  "Description und Icon sind Pflicht.",
  "Success, Info, Warning und Error haben Default-Icons.",
  "Primary bekommt das Icon immer explizit (je nach Kontext).",
  "Action rechts und Titel sind optional.",
  "Meist in Dialogen oder Formularbereichen einsetzen.",
  "Die volle Breite stellt sich selbst her: AppCardBody und AppDialogBody melden ihren Innenabstand über --ds-callout-bleed-inline, der Callout zieht ihn wieder heraus. Niemand rechnet mehr mit eigenen negativen Rändern.",
  "Eigene Container mit Innenabstand melden ihn genauso an: --ds-callout-bleed-inline: <Abstand> auf dem Container, nichts am Callout.",
  "Bewusste Abweichung (z. B. gerundeter Callout in einer Feldspalte): --ds-callout-bleed-inline: 0px lokal setzen.",
];

const niceToKnowHighlights = [
  "→ I.d.R geht ein Callout über die volle Breite ohne Innenpadding (Bsp. Dialog).",
];

const niceToKnowRemark =
  "Ob der INFO-Callout in der Software überhaupt verwendet werden soll, muss geklärt werden. Stattdessen könnte in diesen Fällen auch einfach PRIMARY verwendet werden.";

function CalloutVariantPreview({ item }) {
  return (
    <div className="ds-docs-callout-preview__item">
      <div className="ds-docs-callout-preview__label">{item.label}</div>
      <AppCallout
        variant={item.variant}
        icon={item.icon}
        title={item.title}
        description={item.description}
        action={item.action}
      />
    </div>
  );
}

export default function CalloutsDocs() {
  return (
    <DocsSectionCard title="Callouts">
      <div className="ds-docs-spotlight-grid ds-docs-spotlight-grid--callouts">
        <DocsPreviewPanel>
          <div className="ds-docs-preview-surface ds-docs-callout-preview">
            {calloutVariants.map((item) => (
              <CalloutVariantPreview key={item.variant} item={item} />
            ))}
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow items={niceToKnowItems} highlightItems={niceToKnowHighlights} remark={niceToKnowRemark} />
      </div>
    </DocsSectionCard>
  );
}
